import EventEmitter from './event-emitter';

export default function (method, parentTrigger) {
  return function () {
    const methodEvents = new EventEmitter();

    function trigger(...args) {
      methodEvents.trigger(...args);
      parentTrigger(...args);
    }

    const promise = method(trigger, ...arguments)
      .then(function (res) {
        methodEvents.off();
        return res;
      })
      .catch(function (res) {
        methodEvents.off();
        return Promise.reject(res);
      });

    _.forEach(['on', 'off'], function (methodName) {
      promise[methodName] = (...args) => methodEvents[methodName](...args);
    });

    return promise;
  };
}



// WEBPACK FOOTER //
// ./src/transport/utils/provide-each-call-events.js